// Animation du haut de page : le laser grave « FINISHER BOARD » puis les distances, un chrono
// s'écrit à la craie sur l'ardoise du 5 km, et une médaille tombe sur un crochet.
// Aucun coureur n'est dessiné. Boucle toutes les 12,4 s.
//
// Pour rester léger sur téléphone :
// - l'animation modifie directement les éléments du dessin (pas de bibliothèque) ;
// - elle se met en pause quand elle sort de l'écran ;
// - si le visiteur a demandé moins d'animations (prefers-reduced-motion), on affiche
//   directement l'image finale, sans mouvement.
(function () {
  var LOOP = 12.4;
  var FINAL = 10.2;

  var clamp = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
  var seg = function (t, a, b) { return clamp((t - a) / (b - a)); };
  var ease = function (x) { return 1 - Math.pow(1 - x, 3); };
  var easeIn = function (x) { return x * x; };
  var NS = 'http://www.w3.org/2000/svg';

  // Moments de l'animation, en secondes
  var T = {
    board: [0, 0.7],
    t1: [0.9, 2.1],
    t2: [2.1, 3.0],
    swoosh: [3.0, 3.5],
    dist: [[3.7, 4.3], [4.3, 4.9], [4.9, 5.5], [5.5, 6.1]],
    slates: [6.2, 6.8],
    chalk: 7.0,
    medal: [8.7, 9.3],
    out: [11.7, 12.4]
  };

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var q = function (s) { return root.querySelector(s); };
    var board = q('[data-board]');
    var laser = q('[data-laser]');
    var sparks = q('[data-sparks]');
    var swoosh = q('[data-fade="swoosh"]');
    var chalk = Array.prototype.slice.call(root.querySelectorAll('[data-chalk] path'));
    var slates = Array.prototype.slice.call(root.querySelectorAll('[data-slate]'));
    var medal = q('[data-medal]');
    var swing = q('[data-medal-swing]');
    var reveals = {};
    ['t1', 't2', 'd0', 'd1', 'd2', 'd3'].forEach(function (n) {
      var r = q('[data-reveal="' + n + '"]');
      if (r) reveals[n] = { el: r, x: parseFloat(r.getAttribute('x')), full: parseFloat(r.getAttribute('width')) };
    });
    if (!board || !laser || !sparks || !medal || !swing || !reveals.t1) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var parts = [];
    var lastT = 0;

    function clearSparks() {
      parts.forEach(function (p) { if (p.el.parentNode) p.el.parentNode.removeChild(p.el); });
      parts.length = 0;
    }

    function spawn(x, y) {
      for (var i = 0; i < 3; i++) {
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('r', (Math.random() * 1.6 + 0.8).toFixed(2));
        c.setAttribute('fill', Math.random() < 0.5 ? '#FFD27A' : '#FF8A2A');
        sparks.appendChild(c);
        parts.push({ el: c, x: x, y: y, vx: (Math.random() - 0.5) * 160, vy: -Math.random() * 150 - 30, life: 0, max: 0.35 + Math.random() * 0.3 });
      }
    }

    function setReveal(name, p) {
      reveals[name].el.setAttribute('width', (reveals[name].full * p).toFixed(1));
    }

    function render(elapsed) {
      var t = reduce ? FINAL : elapsed % LOOP;
      if (t < lastT) clearSparks();
      var dt = Math.max(0, Math.min(0.05, t - lastT));
      lastT = t;

      var a = ease(seg(t, T.board[0], T.board[1]));
      var out = reduce ? 1 : 1 - seg(t, T.out[0], T.out[1]);
      var alpha = a * out;
      board.setAttribute('opacity', alpha.toFixed(3));
      board.setAttribute('transform', 'translate(0 ' + ((1 - a) * 24).toFixed(1) + ')');

      var active = false;
      var lx = 0;
      var ly = 0;

      // Le laser grave le titre, ligne par ligne
      var p1 = seg(t, T.t1[0], T.t1[1]);
      var p2 = seg(t, T.t2[0], T.t2[1]);
      setReveal('t1', p1);
      setReveal('t2', p2);
      if (p1 > 0 && p1 < 1) {
        active = true;
        lx = reveals.t1.x + reveals.t1.full * p1;
        ly = 132 + Math.sin(p1 * 40) * 14;
      } else if (p2 > 0 && p2 < 1) {
        active = true;
        lx = reveals.t2.x + reveals.t2.full * p2;
        ly = 188 + Math.sin(p2 * 40) * 14;
      }
      swoosh.setAttribute('opacity', ease(seg(t, T.swoosh[0], T.swoosh[1])).toFixed(3));

      // ... puis les distances
      for (var i = 0; i < 4; i++) {
        var key = 'd' + i;
        var p = seg(t, T.dist[i][0], T.dist[i][1]);
        setReveal(key, p);
        if (p > 0 && p < 1) {
          active = true;
          lx = reveals[key].x + reveals[key].full * p;
          ly = 27 + 85 * i + 24 + Math.sin(p * 30) * 10;
        }
      }

      laser.setAttribute('opacity', active && alpha > 0.5 ? '1' : '0');
      if (active) {
        laser.setAttribute('transform', 'translate(' + lx.toFixed(1) + ' ' + ly.toFixed(1) + ')');
        if (!reduce && dt > 0) spawn(lx, ly);
      }

      // Les ardoises apparaissent
      var s = ease(seg(t, T.slates[0], T.slates[1]));
      slates.forEach(function (g) { g.setAttribute('opacity', s.toFixed(3)); });

      // Le chrono s'écrit à la craie, trait après trait
      chalk.forEach(function (path, k) {
        var cp = ease(seg(t, T.chalk + k * 0.24, T.chalk + k * 0.24 + 0.45));
        path.setAttribute('stroke-dasharray', '1');
        path.setAttribute('stroke-dashoffset', (1 - cp).toFixed(3));
        path.setAttribute('opacity', cp > 0 ? '1' : '0');
      });

      // La médaille tombe sur le crochet, puis se balance
      var md = seg(t, T.medal[0], T.medal[1]);
      var dy = (1 - easeIn(md)) * -520;
      var ang = 0;
      if (t > T.medal[1]) {
        var k2 = t - T.medal[1];
        ang = 14 * Math.exp(-1.5 * k2) * Math.sin(k2 * 7);
        dy = -6 * Math.exp(-9 * k2) * Math.abs(Math.sin(k2 * 16));
      }
      medal.setAttribute('opacity', md > 0 ? (out).toFixed(3) : '0');
      swing.setAttribute('transform', 'translate(0 ' + dy.toFixed(1) + ') rotate(' + ang.toFixed(2) + ')');

      // Étincelles
      for (var j = parts.length - 1; j >= 0; j--) {
        var q2 = parts[j];
        q2.life += dt;
        q2.vy += 420 * dt;
        q2.x += q2.vx * dt;
        q2.y += q2.vy * dt;
        if (q2.life > q2.max) {
          if (q2.el.parentNode) q2.el.parentNode.removeChild(q2.el);
          parts.splice(j, 1);
          continue;
        }
        q2.el.setAttribute('cx', q2.x.toFixed(1));
        q2.el.setAttribute('cy', q2.y.toFixed(1));
        q2.el.setAttribute('opacity', (1 - q2.life / q2.max).toFixed(2));
      }
    }

    if (reduce) {
      render(FINAL);
      root.classList.add('is-ready');
      return;
    }

    var raf = 0;
    var running = false;
    var start = performance.now();
    var pausedAt = start;

    function frame(now) {
      render((now - start) / 1000);
      raf = requestAnimationFrame(frame);
    }
    function play() {
      if (running) return;
      running = true;
      start += performance.now() - pausedAt;
      raf = requestAnimationFrame(frame);
    }
    function pause() {
      if (!running) return;
      running = false;
      pausedAt = performance.now();
      cancelAnimationFrame(raf);
    }

    render(0);
    root.classList.add('is-ready');

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) play();
        else pause();
      }).observe(root);
    } else {
      play();
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hero-anim]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
